import { useCallback, useEffect, useState } from "react";
import modelService from "../services/modelService";

const useGetCollection = <T>(path: string, filter: any = null) => {
	const [data, setData] = useState<T | null>(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<Error | null>(null);

	const fetchData = useCallback(async () => {
		setLoading(true);
		setError(null);

		try {
			const result = await modelService.readCollection<T>(path, filter);
			setData(result);
		} catch (error) {
			setError(error as Error);
		} finally {
			setLoading(false);
		}
	}, [path, filter]);

	useEffect(() => {
		fetchData();
	}, [fetchData]);

	return { data, loading, error, refresh: fetchData };
};

export default useGetCollection;
